import { RootState } from "./reducers";

// Auth
export const TOKEN = (store: RootState) => store.auth.token;
export const AUTH_USER = (store: RootState) => store.auth.user;
export const IS_SUPER_ADMIN = (store: RootState) => store.auth.isSuperAdmin;

// School
export const SCHOOLS = (store: RootState) => store.school.schools;
export const LOADING_SCHOOL = (store: RootState) => store.school.loading;

// Lessons
export const LESSONS = (store: RootState) => store.lesson.lessons;
export const LOADING_LESSONS = (store: RootState) => store.lesson.loading;
export const LESSONS_PAGINATION = (store: RootState) => store.lesson.pagination;

// Courses
export const COURSES = (store: RootState) => store.course.courses;
export const LOADING_COURSES = (store: RootState) => store.course.loading;
export const COURSES_PAGINATION = (store: RootState) => store.course.pagination;

// Subjects
export const SUBJECTS = (store: RootState) => store.subject.subjects;
export const LOADING_SUBJECTS = (store: RootState) => store.subject.loading;

// Resources
export const RESOURCES = (store: RootState) => store.resource.resources;
export const LOADING_RESOURCES = (store: RootState) => store.resource.loading;

// Grades
export const GRADES = (store: RootState) => store.grade.grades;
export const LOADING_GRADES = (store: RootState) => store.grade.loading;

// Programs
export const PROGRAM = (store: RootState) => store.program.programs;
export const LOADING_PROGRAM = (store: RootState) => store.program.loading;

// Calendar (one general calendar per education level — SCRUM-744)
export const CALENDARS = (store: RootState) => store.calendar.calendars;
export const LOADING_CALENDAR = (store: RootState) => store.calendar.loading;

// Game Quizzes
export const GAME_QUIZZES = (store: RootState) => store.gameQuiz.gameQuizzes;
export const CURRENT_GAME_QUIZ = (store: RootState) =>
  store.gameQuiz.currentGameQuiz;
export const LOADING_GAME_QUIZZES = (store: RootState) =>
  store.gameQuiz.loading;
export const LOADING_GAME_QUIZ_DETAIL = (store: RootState) =>
  store.gameQuiz.loadingDetail;
export const GAME_QUIZZES_PAGINATION = (store: RootState) =>
  store.gameQuiz.pagination;
// Tienda Colegios
export const TIENDA_COLEGIOS = (store: RootState) =>
  store.tiendaColegio.tiendaColegios;
export const LOADING_TIENDA_COLEGIO = (store: RootState) =>
  store.tiendaColegio.loading;

// Tienda Paquetes
export const TIENDA_PAQUETES = (store: RootState) =>
  store.tiendaPaquete.tiendaPaquetes;
export const LOADING_TIENDA_PAQUETE = (store: RootState) =>
  store.tiendaPaquete.loading;

export const VENTAS = (store: RootState) => store.ventas.ventas;
export const LOADING_VENTAS = (store: RootState) => store.ventas.loading;
